const FONT = {
  SIZE: {
    HEROTITLE: "1.5rem",
    BIGTITLE: "1.4rem",
    TITLE1: "1.3rem",
    TITLE2: "1.2rem",
    TITLE3: "1rem",
    HEADLINE: "0.9rem",
    BODY: "0.8rem",
    FOOTNOTE: "0.7rem",
    CAPTION: "0.6rem",
  },
  WEIGHT: {
    REGULAR: 400,
    MEDIUM: 500,
    SEMIBOLD: 600,
    BOLD: 700,
  },
} as const;

export default FONT;
